exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader{position:fixed;top:0;left:0;width:100%;height:100%;background:#f1f1f0;z-index:99999}.loader img{width:200px;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}", ""]);

// exports
